/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari9
 * @extends com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8
 * @constructor
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari9 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari9.__super__.call(this);
};

$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8,		// The extend defines the __super__
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari9,
	"com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari9"
);